import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23bd96ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OSeletorSemanal p-fluid",
  "data-testid": "OSeletorSemanal"
}
const _hoisted_2 = { class: "OSeletorSemanal__Input" }
const _hoisted_3 = {
  key: 0,
  class: "OSeletorSemanal__Rotulo",
  for: "seletor-semanal"
}
const _hoisted_4 = {
  id: "seletor-semanal",
  class: "OSeletorSemanal__Seletor p-buttonset"
}
const _hoisted_5 = {
  id: "seletor-semanal-mensagem-de-erro",
  class: "OSeletorSemanal__MensagemDeErro p-error",
  "data-testid": "seletor-semanal-mensagem-de-erro"
}

import { computed, onMounted, Ref, ref, watch } from "vue"
  import SelectButton from "primevue/selectbutton"
  import { useI18n } from "vue-i18n"

  interface Props {
    dataBase: Date
    valorInicial?: number[]
    rotulo?: string | Ref<string>
    mensagemDeErro?: string | Ref<string>
  }

  type RotuloDiaDaSemana = "D" | "S" | "T" | "Q" | "S"
  type DiaDaSemanaPorExtenso =
    | "Domingo"
    | "Segunda-feira"
    | "Terça-feira"
    | "Quarta-feira"
    | "Quinta-feira"
    | "Sexta-feira"
    | "Sábado"

  type ClassesCSS = Record<string, boolean>
  type IndiceDeLista = number

  interface DiaDaSemana {
    rotulo: RotuloDiaDaSemana
    nome: DiaDaSemanaPorExtenso
    classes: ClassesCSS
    selecionado: boolean
    valor: number
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OSeletorSemanal',
  props: {
    dataBase: null,
    valorInicial: null,
    rotulo: null,
    mensagemDeErro: null
  },
  emits: ["onMapearDiasSelecionados"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "onMapearDiasSelecionados", listaDeIndices: number[])
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    dataBase: Date
    valorInicial?: number[]
    rotulo?: string | Ref<string>
    mensagemDeErro?: string | Ref<string>
  }

  

  

  const { t } = useI18n()

  const dataBaseInterna = computed(() => {
    const data = props.dataBase
    const ano = data.getFullYear()
    const mes = `00${data.getMonth() + 1}`.slice(-2)
    const dia = `00${data.getDate()}`.slice(-2)

    return `${ano}/${mes}/${dia}`
  })

  const listaDeDiasSelecionados: Ref<number[]> = ref([])
  const listaDeDiasMapeados: Ref<number[]> = ref([])

  const listaDeDiasDaSemana = ref<DiaDaSemana[]>([
    {
      rotulo: t("listaDeDiasDaSemana.domingo.rotulo") as RotuloDiaDaSemana,
      valor: 1,
      nome: t("listaDeDiasDaSemana.domingo.nome") as DiaDaSemanaPorExtenso,
      classes: {},
      selecionado: false,
    },
    {
      rotulo: t("listaDeDiasDaSemana.segunda.rotulo") as RotuloDiaDaSemana,
      valor: 2,
      nome: t("listaDeDiasDaSemana.segunda.nome") as DiaDaSemanaPorExtenso,
      classes: {},
      selecionado: false,
    },
    {
      rotulo: t("listaDeDiasDaSemana.terca.rotulo") as RotuloDiaDaSemana,
      valor: 3,
      nome: t("listaDeDiasDaSemana.terca.nome") as DiaDaSemanaPorExtenso,
      classes: {},
      selecionado: false,
    },
    {
      rotulo: t("listaDeDiasDaSemana.quarta.rotulo") as RotuloDiaDaSemana,
      valor: 4,
      nome: t("listaDeDiasDaSemana.quarta.nome") as DiaDaSemanaPorExtenso,
      classes: {},
      selecionado: false,
    },
    {
      rotulo: t("listaDeDiasDaSemana.quinta.rotulo") as RotuloDiaDaSemana,
      valor: 5,
      nome: t("listaDeDiasDaSemana.quinta.nome") as DiaDaSemanaPorExtenso,
      classes: {},
      selecionado: false,
    },
    {
      rotulo: t("listaDeDiasDaSemana.sexta.rotulo") as RotuloDiaDaSemana,
      valor: 6,
      nome: t("listaDeDiasDaSemana.sexta.nome") as DiaDaSemanaPorExtenso,
      classes: {},
      selecionado: false,
    },
    {
      rotulo: t("listaDeDiasDaSemana.sabado.rotulo") as RotuloDiaDaSemana,
      valor: 7,
      nome: t("listaDeDiasDaSemana.sabado.nome") as DiaDaSemanaPorExtenso,
      classes: {},
      selecionado: false,
    },
  ])

  const obterIndiceMapeado = (
    indiceParaMapear: IndiceDeLista
  ): IndiceDeLista => {
    const indiceDoDiaBaseNaSemana = new Date(dataBaseInterna.value).getDay()
    const numeroDeDiasDaSemana = 7

    if (indiceParaMapear > indiceDoDiaBaseNaSemana) {
      return indiceParaMapear - indiceDoDiaBaseNaSemana
    } else {
      const numeroDeDiasParaRecuar = indiceDoDiaBaseNaSemana - indiceParaMapear
      return numeroDeDiasDaSemana - numeroDeDiasParaRecuar
    }
  }

  const atualizarSetMapeandoDiasSelecionados = () => {
    listaDeDiasMapeados.value = [...listaDeDiasSelecionados.value].map(
      (diaSelecionado) => obterIndiceMapeado(diaSelecionado)
    )
  }

  watch(dataBaseInterna, () => {
    atualizarSetMapeandoDiasSelecionados()
  })

  watch(
    listaDeDiasMapeados,
    () => {
      emitir("onMapearDiasSelecionados", listaDeDiasMapeados.value)
    },
    { deep: true }
  )

  onMounted(() => {
    if (props.valorInicial) {
      listaDeDiasSelecionados.value = [...props.valorInicial]
      atualizarSetMapeandoDiasSelecionados()
      emitir("onMapearDiasSelecionados", listaDeDiasMapeados.value)
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.rotulo)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(__props.rotulo), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(SelectButton), {
          modelValue: listaDeDiasSelecionados.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((listaDeDiasSelecionados).value = $event)),
          onChange: atualizarSetMapeandoDiasSelecionados,
          multiple: "",
          "option-label": "rotulo",
          "option-value": "valor",
          options: listaDeDiasDaSemana.value
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _createElementVNode("small", _hoisted_5, _toDisplayString(__props.mensagemDeErro), 1)
  ]))
}
}

})